// DcInfoDict.js
// DbdbTap 2024-08-26 14:12:52
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";
import ValueMisc from "../../value/ValueMisc";

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    dcCd : {
			id: 'dcCd', label: '출발지코드',
			type: InputType.text, required: true, toAdd: true, toEdit: true,
			help: '901~999 (중복불가)',
			check: (value) => {return IsValid.regex(value, /^9[0-9]{2}$/)},
		},
    dcName : {
			id: 'dcName', label: '출발지',
			type: InputType.text, required: true, toAdd: true, toEdit: true,
			help: '20자 이내로 입력하세요.',
			check: (value) => {return IsValid.string(value, 1, 20)},
		},
    dcTypeCd : {
			id: 'dcTypeCd', label: 'DC구분',
			type: InputType.select, required: true, toAdd: true, toEdit: true,
            default: 'A',
		},
    zipCd : {
			id: 'zipCd', label: '우편번호',
			type: InputType.text, required: false, toAdd: true, toEdit: true,
			help: 'NNN-NNN형식으로 입력하세요.',
			check: (value) => {return IsValid.nullString(value) || IsValid.zipCode(value)},
		},
    addr : {
			id: 'addr', label: '주소',
			type: InputType.text, required: false, toAdd: true, toEdit: true,
			help: '30자 이내로 입력하세요.',
			check: (value) => {return IsValid.string(value, 0, 100)},
		},
    docknoStart : {
			id: 'docknoStart', label: '시작 도크번호',
			type: InputType.text, required: false, toAdd: true, toEdit: true,
			help: '3자 이내 숫자로 입력하세요.',
            default: '1',
			check: (value) => {return IsValid.numericString(value, 0, 3)},
		},
    docknoEnd : {
			id: 'docknoEnd', label: '마지막 도크번호',
			type: InputType.text, required: false, toAdd: true, toEdit: true,
			help: '3자 이내 숫자로 입력하세요.',
            default: '500',
			check: (value) => {return IsValid.numericString(value, 0, 3)},
		},
    officeTelno : {
			id: 'officeTelno', label: 'DC 전화번호',
			type: InputType.text, required: false, toAdd: true, toEdit: true,
			help: '15자 이내로 입력하세요.',
			check: (value) => {return IsValid.string(value, 0, 15)},
		},
    officeStaffName : {
			id: 'officeStaffName', label: 'DC 담당자',
			type: InputType.text, required: false, toAdd: true, toEdit: true,
			help: '18자 이내로 입력하세요.',
			check: (value) => {return IsValid.string(value, 0, 18)},
		},
    secuTelno : {
			id: 'secuTelno', label: '보안실전화',
			type: InputType.text, required: false, toAdd: true, toEdit: true,
			help: '16자 이내로 입력하세요.',
			check: (value) => {return IsValid.string(value, 0, 16)},
		},
    secuStaffName : {
			id: 'secuStaffName', label: '보안실 담당자',
			type: InputType.text, required: false, toAdd: true, toEdit: true,
			help: '12자 이내로 입력하세요.',
			check: (value) => {return IsValid.string(value, 0, 12)},
		},
    transStaffName : {
			id: 'transStaffName', label: 'TRANS담당',
			type: InputType.text, required: false, toAdd: true, toEdit: true,
			help: '15자 이내로 입력하세요.',
			check: (value) => {return IsValid.string(value, 0, 15)},
		},
    operStaffName : {
			id: 'operStaffName', label: 'OPER담당',
			type: InputType.text, required: false, toAdd: true, toEdit: true,
			help: '15자 이내로 입력하세요.',
			check: (value) => {return IsValid.string(value, 0, 15)},
		},
    pierTimeIntervalCd : {
			id: 'pierTimeIntervalCd', label: '접안간격',
			type: InputType.text, required: false, toAdd: true, toEdit: true,
			help: '2자 이내로 입력하세요.',
			check: (value) => {return IsValid.string(value, 0, 2)},
		},
    tempFore : {
			id: 'tempFore', label: '전면온도',
			type: InputType.number, required: false, toAdd: true, toEdit: true,
			check: (value) => {return value >= -999 && value <= 999},
		},
    tempMid : {
			id: 'tempMid', label: '중면온도',
			type: InputType.number, required: false, toAdd: true, toEdit: true,
			check: (value) => {return value >= -999 && value <= 999},
		},
    tempRear : {
			id: 'tempRear', label: '후면온도',
			type: InputType.number, required: false, toAdd: true, toEdit: true,
			check: (value) => {return value >= -999 && value <= 999},
		},
    useTransType : {
        id: 'useTransType', label: '물류집기 온도 설정',
        type: InputType.radioForBoolean, required: false, toAdd: true, toEdit: true,
        select: {
            true: '배차구분정보의 온도 사용',
            false: 'DC 설정 사용',
        }
        // 과거 UI에서 상차 상세내역/ 물류집기 모달 띄울 때
        // 이 값이 참이면 TRANS_TYPE_CD 코드의 온도(code_1,2,3)를 사용하고
        // 거짓이면 DC_INFO의 tempFore, tempMid, tempRear를 사용함
    },
    fontColor : {
			id: 'fontColor', label: '지도 전경색',
			type: InputType.text, required: false, toAdd: true, toEdit: true,
			//help: '12자 이내로 입력하세요.',
			//check: (value) => {return IsValid.string(value, 0, 12)},
		},
    backColor : {
			id: 'backColor', label: '지도 배경색',
			type: InputType.text, required: false, toAdd: true, toEdit: true,
			//help: '12자 이내로 입력하세요.',
			//check: (value) => {return IsValid.string(value, 0, 12)},
		},
    
};

/**
 * DC_INFO React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-08-26 14:12:52 using DbdbTap
 */
export const DcInfoDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '출발지 정보 등록 오류',
        Edit: '출발지 정보 수정 오류',
        Remove: '출발지 정보 삭제 오류',
        Get: '출발지 정보 조회 오류',
        SetUsage: '출발지 사용여부 설정 오류',
    },
    tableProps: {
        tableId: 'dcInfoTable',
        uniqueKey: 'dcCd',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            { id: 'dcTypeName', label: Dict.dcTypeCd.label, width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcCd', label: Dict.dcCd.label, width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcName', label: Dict.dcName.label, width: 130, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'dcTypeCd', label: Dict.dcTypeCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'zipCd', label: Dict.zipCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'addr', label: Dict.addr.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'officeTelno', label: Dict.officeTelno.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'officeStaffName', label: Dict.officeStaffName.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'secuTelno', label: Dict.secuTelno.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'secuStaffName', label: Dict.secuStaffName.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'docknoStart', label: Dict.docknoStart.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'docknoEnd', label: Dict.docknoEnd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'useYn', label: '사용구분', width: 80, show: true, option:{align: 'inherit', print:(r,i,v)=>v==='Y'?'사용':'사용중지'} },
            { id: 'transStaffName', label: Dict.transStaffName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'operStaffName', label: Dict.operStaffName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'pierTimeInterval', label: Dict.pierTimeIntervalCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'tempFore', label: Dict.tempFore.label, width: 100, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            //{ id: 'tempMid', label: Dict.tempMid.label, width: 100, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            //{ id: 'tempRear', label: Dict.tempRear.label, width: 100, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            //{ id: 'useTransType', label: Dict.useTransType.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.BOOLEAN} },
            //{ id: 'fontColor', label: Dict.fontColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'backColor', label: Dict.backColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regDate', label: "등록일", width: 120, show: true, option:{align: 'inherit', print:(r,i,v)=>ValueMisc.substr(v,0,10)} },
            { id: 'regUserName', label: "등록자", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
    dcListWithRentVehCountProps: {
        tableId: 'dcListWithRentVehCountTable',
        uniqueKey: 'dcCd',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
        },
        columns: [
            { id: 'dcTypeName', label: '센터구분', width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcCd', label: '센터코드', width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcName', label: '물류센터', width: 130, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'countVehicle', label: '차량수', width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
        ]
    }
};
